module.exports = __webpack_public_path__ + "static/media/orders_icon.41f42c57.svg";